// src/theme/atomic/cyan.ts
var cyan = {
  10: "#00252B",
  20: "#004854",
  30: "#006F82",
  40: "#0098B2",
  50: "#00BDDE",
  60: "#28D0ED",
  70: "#57DFF7",
  80: "#8AEDFF",
  90: "#B5F4FF",
  95: "#DEFAFF",
  99: "#F7FEFF"
};
var cyan_default = cyan;

export { cyan_default as default };
